export const MODE_SINGLE_SELECT = "single-select";
export const MODE_MULTIPLE_SELECT = "multiple-select";
export const MODE_PRICE_SELECT = "price-select";
export const DEFAULT_MODE = MODE_MULTIPLE_SELECT;

export const SEARCH_BAR_INSTANCE = "UIMiniItemsSearchBar";

export const NAMESPACE = "UIMiniItemSelector";
